import React from 'react';
import { type UserProfileProps } from '../types';
import { OfficialQuizChip } from './ProfileWidget';
export const ProfileUserInfo = (props: UserProfileProps) => {
  return <div data-sentry-component="ProfileUserInfo" data-sentry-source-file="ProfileUserInfo.tsx">
      <div className={'flex flex-col gap-2xs'}>
        <div className={'flex items-center gap-2xs'}>
          <div className={'w-full text-heading-lg-extrabold text-default'}>
            {props.name}
          </div>
          {props.isAmbassador && <OfficialQuizChip className={'shrink-0 max-tablet-sm:hidden'} />}
        </div>
        <span className={'text-body-md-medium text-alternative'}>
          {props.email}
        </span>
        {props.isAmbassador && <OfficialQuizChip className={'my-xs tablet-sm:hidden'} />}
      </div>
    </div>;
};